import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import { ChartOptions } from 'chart.js';

ChartJS.register(ArcElement, Tooltip);

interface UsagePieChartProps {
    data: { [key: string]: number };
    title: string;
    isCurrency?: boolean;
}

const DEFAULT_COLORS = [
    "#8884d8", "#82ca9d", "#8dd1e1", "#ffc658", "#d0ed57", "#a4de6c"
];

const UsagePieChart: React.FC<UsagePieChartProps> = ({ data, title, isCurrency = false }) => {
    const chartLabels = Object.keys(data);
    const chartValues = Object.values(data);

    const chartData = {
        labels: chartLabels,
        datasets: [
            {
                data: chartValues,
                backgroundColor: DEFAULT_COLORS,
            },
        ],
    };

    const options: ChartOptions<'pie'> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const label = context.label || '';
                        const value = context.raw as number;
                        const formattedValue = isCurrency
                            ? `$${value.toFixed(2)}`
                            : Math.round(value).toLocaleString();
                        return `${label}: ${formattedValue}`;
                    },
                },
            },
        },
    };

    return (
        <div className="flex flex-col items-center mb-6">
            <h3 className="font-semibold mb-3">{title}</h3>
            <div style={{ width: '100%', height: '150px' }}>
                <Pie data={chartData} options={options} />
            </div>
        </div>
    );
};

export default UsagePieChart;